import { darken, lighten } from "../utilities/color";

const baseColors = {
  transparent: "transparent",
  black: "#000",
  white: "#fff",
  primary: "#1b4aa8",
  secondary: "#333",
  info: "#2982cc",
  success: "#1b9e3e",
  warning: "#f6960b",
  danger: "#d93737",
};


const colors = {
  transparent: baseColors.transparent,
  black: baseColors.black,
  white: baseColors.white,
  body: {
    color: "#3c4b64",
    backgroundColor: "#ebedef",
  },
  primary: {
    color: baseColors.primary,
    backgroundColor: lighten(baseColors.primary, 0.125),
    hoverColor: lighten(baseColors.primary, 0.05),
    borderColor: baseColors.primary,
  },
  secondary: {
    color: baseColors.secondary,
    backgroundColor: "#eee",
    hoverColor: darken("#eee", 0.1),
    borderColor: baseColors.secondary,
  },
  info: {
    color: baseColors.info,
    backgroundColor: "#c0e6ff",
    hoverColor: darken("#c0e6ff", 0.1),
    borderColor: baseColors.info,
  },
  success: {
    color: baseColors.success,
    backgroundColor: "#cbedd6",
    hoverColor: darken("#cbedd6", 0.1),
    borderColor: baseColors.success,
  },
  warning: {
    color: baseColors.warning,
    backgroundColor: "#feecc5",
    hoverColor: darken("#feecc5", 0.1),
    borderColor: baseColors.warning,
  },
  danger: {
    color: baseColors.danger,
    backgroundColor: "#f9d4d4",
    hoverColor: darken("#f9d4d4", 0.1),
    borderColor: baseColors.danger,
  },
  input: {
    color: "#768192",
    backgroundColor: baseColors.white,
    borderColor: "#d8dbe0",
    placeholder: {
      color: "#8a93a2",
    },
    focus: {
      color: "#768192",
      backgroundColor: baseColors.white,
      borderColor: baseColors.primary,
    },
    disabled: {
      color: "#8a93a2",
      backgroundColor: "#d8dbe0",
    },
    invalid: {
      borderColor: baseColors.danger.color,
    },
  },
  checkbox: {
    backgroundColor: baseColors.white,
    borderColor: "#9da5b1",
    checked: {
      color: baseColors.white,
      backgroundColor: baseColors.primary.color,
      disabledBackgroundColor: "hsl(226,72%,88%)",
      borderColor: baseColors.primary.color,
    },
    indeterminate: {
      borderColor: baseColors.primary.color,
    },
    active: {
      color: baseColors.white,
      backgroundColor: "hsl(226,72%,88%)",
      borderColor: "hsl(226,72%,88%)",
    },
    invalid: {
      color: baseColors.danger.color,
      backgroundColor: baseColors.white,
      borderColor: baseColors.danger.color,
    },
    disabled: {
      color: "#8a93a2",
      backgroundColor: "#d8dbe0"
    },
  },
  table: {
    borderColor: "#d8dbe0",
    stripeColor: "rgba(0, 0, 21, 0.05)",
    hoverColor: "rgba(0, 0, 21, 0.075)",
    thead: {
      dark: {
        color: baseColors.white,
        backgroundColor: "#636f83",
        borderColor: "#758297",
      }
    }
  },
};

export default colors;
